import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CestaInversion } from 'src/app/funds/shared/_models/cestas-inversion';
import { GenericService } from 'src/app/_services/generic.service';
import { OportunidadFactoring } from '../_models/oportunidad-factoring';
import { OportunidadRealEstate } from '../_models/oportunidad-realestate';
import { ProyectoGaleria } from '../_models/proyecto-galeria';
import { ProyectoHome } from '../_models/proyecto-home';
import { Minificha } from 'src/app/venture/shared/_models/minificha';
import { MinifichaAudiovisual } from 'src/app/creative/public/_models/minificha-audiovisual';

@Injectable({
  providedIn: 'root'
})
export class ProyectosHomeService extends GenericService<void>
{

  constructor(httpClient: HttpClient)
  {
    super(httpClient, "Segofinance", "v2")
  }

  getProyectosHome(plataformaId: string): Observable<ProyectoHome>
  {
    return this._http.get<ProyectoHome>(`${this._apiCoreUrl}v1/Home/Proyecto/${plataformaId}`);
  }

  getProyectoVenture(proyectoId: number): Observable<Minificha>
  {
    return this._http.get<Minificha>(`${this._apiVentureUrl}v1/Proyectos/DetallesById?proyectoId=${proyectoId}`);
  }

  getProyectoFactoring(operacionId: number): Observable<OportunidadFactoring>
  {
    return this._http.get<OportunidadFactoring>(`${this._apiFactoringUrl}v1/Operaciones/${operacionId}`);
  }

  getProyectoRealEstate(proyectoId: number): Observable<OportunidadRealEstate>
  {
    return this._http.get<OportunidadRealEstate>(`${this._apiRealEstateUrl}v1/Proyectos/GetProyectoById?proyectoId=${proyectoId}`);
  }

  getProyectoAudiovisual(proyectoId: number): Observable<MinifichaAudiovisual>
  {
    return this._http.get<MinifichaAudiovisual>(`${this._apiAudiovisual}Proyectos/${proyectoId}`);
  }

  getGaleriaRealEstate(slug: string): Observable<ProyectoGaleria[]>
  {
    return this._http.get<ProyectoGaleria[]>(`${this._apiRealEstateUrl}v1/Proyectos/Documentos/ByTipo?slug=${slug}&tipoDocumentoId=galeria`);
  }

  getCestasMayorRentabilidadFunds(limit: number): Observable<CestaInversion[]>
  {
    //TODO: Pendiente recuperar las de mayor rentabilidad para la home
    //return this._http.get<CestaInversion[]>(`${this._apiFintupFunctionUrl}Cestas/MayorRentabilidad?limit=${limit}`);
    return this._http.get<CestaInversion[]>(`${this._apiFunds}v1/Cestas`);
  }
}
